import React from 'react';

export default ({ className }) => (
  <span className={className}>
    <svg viewBox="0 0 82 82">
        <path d="M9.75,81.66a4.57,4.57,0,0,1-4.58-4.58V4.92A4.58,4.58,0,0,1,12,1L74.53,37a4.58,4.58,0,0,1,0,7.94L12,81.05A4.54,4.54,0,0,1,9.75,81.66Zm3.42-70.82V71.16L65.4,41ZM70.53,44h0Z"/>
    </svg>
  </span>
);